import { ButtonWrap } from "@hopper-b2b/ui";
import BackArrow from "../../assets/client/arrow-back.svg?react";
import styles from "./styles.module.scss";

interface CheckoutHeaderProps {
  onBack?: () => void;
  title?: string;
}

export const CheckoutHeader = ({ onBack, title }: CheckoutHeaderProps) => {
  return (
    <div className={styles.CheckoutHeader}>
      {onBack ? (
        <ButtonWrap onClick={onBack}>
          <BackArrow className="back" />
        </ButtonWrap>
      ) : null}
      {title ? <p className="checkout-title">{title}</p> : null}
    </div>
  );
};
